import { createContext } from "react";
var SignalContext = createContext({
    signals: [],
    dispatch: function () { },
    asyncDispatch: function () { },
});
export default SignalContext;
